module.exports = __webpack_public_path__ + "img/smile5.6f8db3d2.png";